/**
 * Dashboard CrossFrame Listener
 *
 * Handles CrossFrame requests for getDashboardUrl.
 * Delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetDashboardUrlRequest } from '@amzn/coral_com-amazon-physicalstorereportsservice-model/GetDashboardUrlRequest'
import { GetDashboardUrlResponse } from '@amzn/coral_com-amazon-physicalstorereportsservice-model/GetDashboardUrlResponse'
import { validateRequired } from './listenerUtils'

export async function getDashboardUrlListener (message: any): Promise<GetDashboardUrlResponse> {
    const params = (message && message.data) || {}
    validateRequired(params, 'dashboardType')
    const client = getServiceClient()
    return client.getDashboardUrl(GetDashboardUrlRequest.clone(params)).toPromise()
}
